import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  fieldGroup: {
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    marginLeft: 0,
  },
  field: {
    marginTop: theme.spacing(2),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  item: {
    marginTop: theme.spacing(2),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  labelInput: {
    fontSize: '16px',
  },
}))

export default useStyles
